// Admin growth charts (docs/ops-and-account-acceptance-criteria.md G).
// Money arrives as strings: Number() it before charting.

export const BILL_COLOURS: Record<string, string> = {
  // Same as hethera-user-dashboard's theme.category, so both apps match.
  AIRTIME: '#2a78d6',
  MOBILE_DATA: '#eb6834',
  CABLE_TV: '#1baf7a',
  ELECTRICITY: '#eda100',
  OTHER: '#8a8f87',
};

export const BILL_LABELS: Record<string, string> = {
  AIRTIME: 'Airtime',
  MOBILE_DATA: 'Data',
  CABLE_TV: 'Cable TV',
  ELECTRICITY: 'Electricity',
};

export interface UserPoint {
  period: string;
  label: string;
  new_users: number;
  onboarded: number;
  cumulative_onboarded?: number;
}

export interface UsersSeries {
  year: number;
  month?: number;
  series: UserPoint[];
  total_new: number;
  total_onboarded: number;
}

export interface TopDays {
  records: { rank: number; date: string; weekday: string; onboarded: number }[];
  totalPages: number;
  totalRecords: number;
  weekdays: { weekday: string; total: number; average: number }[];
  from: string;
  to: string;
}

export interface Ranked {
  key: string;
  count: number;
  value: string;
}

export interface PurchasesYear {
  year: number;
  series: { period: string; label: string; count: number; value: string; service_fees: string; by_bill_type: Record<string, string> }[];
  total_count: number;
  total_value: string;
  busiest_month: { period: string; label: string; count: number; value: string } | null;
  busiest_day: { date: string; weekday: string; count: number; value: string } | null;
  top_bill_type: Ranked | null;
  top_provider: Ranked | null;
  by_bill_type: Ranked[];
  by_provider: Ranked[];
}

export interface YearRow {
  year: number;
  new_users: number;
  onboarded: number;
  purchases: number;
  value: string;
  onboarded_change_pct: number | null;
  purchases_change_pct: number | null;
  value_change_pct: number | null;
  monthly_purchases: number[];
  monthly_onboarded: number[];
}
